<template>
  <div class="contrato">
    <div v-if="loader" class="iloader row justify-center align-center">
      <Loader />
    </div>
    <div class="buttons text-center">
      <div v-if="status == 'pendente'" class="warn">A assinatura do contrato está <b>PENDENTE</b> de aprovação
        cadastral.
      </div>
      <div v-if="status == 'assinado'" class="ok">Contrato assinado.</div>
      <div v-if="status == 'em_processamento'" class="ok">Contrato em processamento.</div>
      <div v-if="status == 'aguardando_assinatura'" class="ok">Aguardando assinatura.</div>
      <div v-if="status == 'cancelado'" class="error">Contrato cancelado.</div>
      <div v-if="contrato && contrato.assinado_em && contrato.assinado_em.length" class="info text-center">Assinado
        em<br />{{ contrato.assinado_em | date }}</div>
      <div v-if="status == 'expirado'" class="error">Contrato expirado.</div>
      <Button v-if="status == 'pendente' || status == 'cancelado' || status == 'expirado'" :loader="load"
        layout="green-m" @click="novoContrato">GERAR NOVO CONTRATO</Button>
    </div>
    <Clicksign v-if="minuta.length || id.length" :minuta="minuta" :id="id" :modal="modal" />
  </div>
</template>

<script>
import Loader from "@/components/Loader";
import Clicksign from "@/components/modal/Clicksign.vue";
import { mapActions, mapGetters } from "vuex";
import Button from "@/components/Button.vue";

export default {
  components: { Clicksign, Button, Loader },
  props: { modal: Object },
  data() {
    return { load: false, loader: true, minuta: "", id: "", status: "", contrato: {} };
  },
  methods: {
    ...mapActions("user", ["CLICKSIGN_DOWNLOAD", "CLICKSIGN_CONTRATO", "CLICKSIGN_NOVO_CONTRATO_EXCECAO"]),
    novoContrato() {
      this.load = true
      this.CLICKSIGN_NOVO_CONTRATO_EXCECAO({id:this.modal.id_doutor, operacao: 'assinatura_contrato' })
        .then(({ data }) => {
          if (data.status) {
            this.contrato = data
            this.status = data.status
            this.load = false
            this.$forceUpdate()
          }
        }).catch(() => this.load = false)
    }
  },
  beforeMount() {
    this.CLICKSIGN_CONTRATO({ op: 'assinatura_contrato' }).then(({ data }) => {

      if (data && data.status) {

        this.contrato = data
        this.status = data.status

        if (this.status == 'disponivel_download' || this.status == 'assinado') {
          this.CLICKSIGN_DOWNLOAD(this.modal.id_doutor)
            .then(({ data }) => {
              if (data.arquivo_base64) this.minuta = data.arquivo_base64
              this.loader = false
            }).catch(() => this.loader = false)
        }

        this.loader = false
      }
    })
  },
  computed: {
    ...mapGetters("user", ["user"])
  }
}
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;

.contrato {
  color: $gray-6;
  padding: 10px 30px;
  max-width: 900px;
  border-radius: 12px;
  background: $white;

  .iloader {
    min-height: 200px;
  }

  .buttons {
    padding: 20px;

    .button {
      margin-top: 20px;
    }
  }

  .status {
    margin-left: -21%;
  }

  .info {
    color: $purple;
  }

  .ok {
    color: $purple;
    font-size: 15px;
    font-weight: bold;
    margin-bottom: 12px;
  }

  .warn,
  .error {
    color: $red-1;
    font-size: 15px;
    margin-bottom: 12px;
    font-weight: bold;
  }
}
</style>